import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static targets = ["chart"];
  static values = { data: Array };

  connect() {
    this.#renderChart();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  // Private

  #renderChart() {
    const data = this.dataValue;
    const categories = data.map((d) => d.label);
    const counts = data.map((d) => d.count);

    const options = {
      chart: {
        type: "bar",
        height: 200,
        background: "transparent",
        toolbar: { show: false },
        animations: { speed: 400, animateGradually: { enabled: false } },
      },
      series: [{ name: "Scans", data: counts }],
      xaxis: {
        categories,
        labels: {
          style: {
            colors: Array(categories.length).fill("rgba(245, 221, 215, 0.3)"),
            fontSize: "10px",
            fontWeight: 700,
            fontFamily: "Inter, sans-serif",
          },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
        crosshairs: { show: false },
      },
      yaxis: { show: false },
      grid: { show: false },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          columnWidth: "55%",
        },
      },
      colors: ["rgba(255, 181, 160, 0.6)"],
      states: {
        hover: { filter: { type: "darken", value: 0.9 } },
        active: { filter: { type: "none" } },
      },
      dataLabels: { enabled: false },
      tooltip: {
        custom({ series, seriesIndex, dataPointIndex }) {
          const val = series[seriesIndex][dataPointIndex];
          const label = categories[dataPointIndex];
          return `<div style="
            background: #352723;
            border: 1px solid rgba(255,181,160,0.15);
            border-radius: 8px;
            padding: 8px 14px;
            font-family: Inter, sans-serif;
            box-shadow: 0 8px 24px rgba(0,0,0,0.4);
          ">
            <div style="color: rgba(245,221,215,0.5); font-size: 11px; font-weight: 600; margin-bottom: 2px;">${label}</div>
            <div style="color: #ffb5a0; font-size: 20px; font-weight: 900;">${val} <span style="color: rgba(245,221,215,0.4); font-size: 13px; font-weight: 500;">scans</span></div>
          </div>`;
        },
      },
      theme: { mode: "dark" },
    };

    this.chart = new ApexCharts(this.chartTarget, options);
    this.chart.render();
  }
}
